import {connect} from "react-redux";
import ActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {markAttendances, getActivity, userCheckout, activityTypes, newActivity, dealerById, getSenior} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails:state.Dealer.markAttendance,
    getActivityDetails:state.Dealer.getActivity,
    isCheckoutDetails:state.Dealer.isCheckoutDetails,
    dealerByIdDetails:state.Dealer.dealerById,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    NewActivityDetails:state.Dealer.saveNewActivity,
    senior:state.Dealer.senior,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markAttendances,
            getActivity,
            newActivity,
            userCheckout,
            activityTypes,
            dealerById,
            getSenior,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ActivitySave);
